import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import ModalTransition from '../../ModalTransition/ModalTransition';
import './Footer.css';

/**
 * Component FooterModal
 * @param {bool} props.isVisible
 * @param {func} props.handleClose
 * @param {object} props.translations
 * @param {object} props.legalInfo
 */
const FooterModal = (props) => {
  const listLabel = {
    header: '',
    content: '',
  }
  switch (props.type) {
    case 'privacyPolicy':
      listLabel.header = props.translations.privacyPolicy;
      listLabel.content = window.atob(props.legalInfo.privacyPolicy);
      break;
    default:
      listLabel.header = props.translations.salesTermsAndConditions;
      listLabel.content = window.atob(props.legalInfo.salesTermsAndConditions);
      break;
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <ModalTransition
      open={props.isVisible}
      handleClose={props.handleClose}
      header={listLabel.header}
      content={
        <Modal.Description>
          <div dangerouslySetInnerHTML={{ __html: listLabel.content }} />
        </Modal.Description>
      }
      actions={
        <Button
          primary
          content={props.translations.close}
          onClick={props.handleClose}
        />
      }
    />
  )
}

export default FooterModal;